export default __webpack_public_path__ + "static/media/corporation.f17517fe.svg";